import { render, staticRenderFns } from "./PromptYesNo.vue?vue&type=template&id=264ef46a"
import script from "./PromptYesNo.vue?vue&type=script&lang=ts"
export * from "./PromptYesNo.vue?vue&type=script&lang=ts"
import style0 from "./PromptYesNo.vue?vue&type=style&index=0&id=264ef46a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports